import React from 'react'

import styled from '@emotion/styled'
import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  Heading1,
  Heading3,
  JustifyContent,
  TextAlign,
} from '@gousto-internal/citrus-react'
import type { Map as ImmutableMap } from 'immutable'

const OfferBoxContainer = styled(Box)`
  flex-wrap: wrap;
  overflow: hidden;
  position: relative;
  width: 100%;
  gap: 1em;
`

const OfferBox = styled(Box)`
  align-items: center;
  background: rgb(208, 170, 70);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  max-width: 359px;
  flex: 1;
  padding: 16px;
  text-align: center;
  * {
    margin: 0;
    display: block;
  }
`

const FlexDiv = styled.div`
  align-items: baseline;
  display: flex;
  gap: 8px;
  justify-content: center;
`

const PlusConnector = styled.div`
  align-items: center;
  background: #5e7183;
  border-radius: 50%;
  color: #fff;
  display: flex;
  font-size: 24px;
  height: 50px;
  justify-content: center;
  left: 50%;
  padding: 0 5px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  z-index: 1;
`

const Plus = styled.span`
  font-weight: 600;
`

const Strikethrough = styled.span`
  text-decoration: line-through;
  font-size: 24px;
`

interface RAFBoostOfferBoxesProps {
  rafOffer: ImmutableMap<string, any>
}

export const RAFBoostOfferBoxes = ({ rafOffer }: RAFBoostOfferBoxesProps) => {
  const originalReferrerCredit = rafOffer.getIn([
    'originalCampaignDetails',
    'creditFormatted',
  ]) as string
  const originalRefereeFirstBoxDiscount = rafOffer.getIn([
    'originalCampaignDetails',
    'firstBoxDiscountFormatted',
  ]) as string
  const boostedReferrerCredit = rafOffer.get('creditFormatted') as string
  const boostedRefereeFirstBoxDiscount = rafOffer.get('firstBoxDiscountFormatted') as string
  const boostedRefereeSecondBoxDiscount = rafOffer.get('secondBoxDiscountFormatted') as string
  const boostedRefereeFirstMonthDiscount = rafOffer.get('firstMonthDiscountFormatted') as string
  const discountDuration = rafOffer.getIn(['discountDuration', 'formatted']) as string

  return (
    <OfferBoxContainer
      display={Display.Flex}
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Stretch}
    >
      <OfferBox>
        <Heading3 textAlign={TextAlign.Center}>Your friend gets</Heading3>
        <FlexDiv>
          <Heading1>{boostedRefereeFirstBoxDiscount}</Heading1>
          {boostedRefereeFirstBoxDiscount !== originalRefereeFirstBoxDiscount && (
            <Strikethrough>{originalRefereeFirstBoxDiscount}</Strikethrough>
          )}
        </FlexDiv>
        <Body2 color={Color.ColdGrey_800} textAlign={TextAlign.Center}>
          {`off their first box, ${boostedRefereeSecondBoxDiscount} off their 2nd box, and ${boostedRefereeFirstMonthDiscount} off their first ${discountDuration}`}
        </Body2>
      </OfferBox>
      <PlusConnector>
        <Plus>+</Plus>
      </PlusConnector>
      <OfferBox>
        <Heading3>You get</Heading3>
        <FlexDiv>
          <Heading1 textAlign={TextAlign.Center}>{boostedReferrerCredit}</Heading1>{' '}
          {boostedReferrerCredit !== originalReferrerCredit && (
            <Strikethrough>{originalReferrerCredit}</Strikethrough>
          )}
        </FlexDiv>
        <Body2 color={Color.ColdGrey_800} textAlign={TextAlign.Center}>
          credit when your friend gets their first box
        </Body2>
      </OfferBox>
    </OfferBoxContainer>
  )
}
